import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CartIconPipe, CartTooltipPipe } from "@gloria-public/risk/domain/pipes/cart.pipe";
import { LocalizedDatePipe } from "@shared/pipes/localized-date.pipe";
import { MinorUnitCurrencyPipe } from "@shared/pipes/minor-unit-currency.pipe";
import { PluralTranslatePipe } from "@shared/pipes/plural-translate.pipe";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { CarouselModule } from "../carousel/carousel.module";
import { ServiceRequestDialogComponent } from "./service-request-dialog.component";

const materialModules = [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule];

@NgModule({
  declarations: [ServiceRequestDialogComponent],
  imports: [
    CommonModule,
    CommonTranslateModule,
    CartIconPipe,
    CartTooltipPipe,
    CarouselModule,
    LocalizedDatePipe,
    MinorUnitCurrencyPipe,
    PluralTranslatePipe,
    ...materialModules,
  ],
  exports: [ServiceRequestDialogComponent],
})
export class ServiceRequestDialogModule {}
